export default __webpack_public_path__ + "static/media/profile.ff20f89f.png";